module.exports = __webpack_public_path__ + "img/blacktrash.8270c774.svg";